import { useTranslation } from 'react-i18next';
import { BankruptcyJobStatus } from '../../Containers/BankruptcyTermination.types';

const config: Record<BankruptcyJobStatus, { labelKey: string; className: string }> = {
    [BankruptcyJobStatus.Running]: { labelKey: 'bankruptcytermination.statusRunning', className: 'label label-info' },
    [BankruptcyJobStatus.Completed]: { labelKey: 'bankruptcytermination.statusCompleted', className: 'label label-success' },
    [BankruptcyJobStatus.Failed]: { labelKey: 'bankruptcytermination.statusFailed', className: 'label label-danger' },
};

interface JobStatusBadgeProps {
    status: BankruptcyJobStatus;
}

const JobStatusBadge = ({ status }: JobStatusBadgeProps) => {
    const { t } = useTranslation();

    const entry = config[status];
    if (entry === undefined) return null;
    const { labelKey, className } = entry;
    return <span className={className}>{t(labelKey)}</span>;
};

export default JobStatusBadge;
